import { render, staticRenderFns } from "./ListSelectedDatarutasVisitPointsItem.vue?vue&type=template&id=20fd2a87&scoped=true"
import script from "./ListSelectedDatarutasVisitPointsItem.vue?vue&type=script&lang=js"
export * from "./ListSelectedDatarutasVisitPointsItem.vue?vue&type=script&lang=js"
import style0 from "./ListSelectedDatarutasVisitPointsItem.vue?vue&type=style&index=0&id=20fd2a87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd2a87",
  null
  
)

export default component.exports